// lib
import React from "react";
import PropTypes from "prop-types";
import { Snackbar } from "@material-ui/core";
import IconButton from "@material-ui/core/IconButton";
import CloseIcon from "@material-ui/icons/Close";

const Warning = ({ message, open, onClose }) => (
  <Snackbar
    className="app-snackbar-warning"
    open={open}
    message={message}
    action={
      <div className="app-snackbar-close">
        <IconButton size="small" aria-label="close" color="inherit" onClick={onClose}>
          <CloseIcon fontSize="small" />
        </IconButton>
      </div>
    }
  />
);

Warning.propTypes = {
  message: PropTypes.string.isRequired,
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
};

export default Warning;
